const isPermissionIncluded = (globalPermissions = [], pagePermissions = []) => {
  return (
    pagePermissions.filter((p) => globalPermissions.includes(p)).length ===
    pagePermissions.length
  )
}

export default isPermissionIncluded
